import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { get } from "lodash";
import { I18n } from "@aws-amplify/core";

import TrainCard from "./TrainCard";
import { isRailcarVisible } from "./HelperFunctions";
import { ReactComponent as ReverseIcon } from "./assets/eva_flip_2_fill.svg"

const styles = {
  railcarContainer: {
    display: "flex",
    flexDirection: "column",
  },
  railcarCarousel: {
    display: "grid",
    gridTemplateColumns: "repeat(7,1fr)",
    gridTemplateRows: "repeat(4,1fr)",
    gridAutoRows: "repeat(4,1fr)",
    maxWidth: "calc((110px + 32px) * (21 / 3))",
    minWidth: "860px",
    minHeight: "582px",
    gridGap: "8px 8px",
    maxHeight: "582px",
    margin: "10px auto 0",
    padding: "0 10px 10px",
    overflowY: "auto",
  },
  railcarCarouselLarge: {
    gridTemplateColumns: "repeat(9,1fr)",
    maxWidth: "calc((110px + 32px) * (27 / 3))",
  },
  actionText: {
    color: "#5f00a0",
    fontWeight: "500",
    cursor: "pointer"
  },
  trainReverse: {
    display: "flex",
    alignItems: "center",
    paddingLeft: "10px",
  },
  reverseButton: {
    backgroundColor: "white",
  },
  addButton: {
    margin: "0 0 0 24px",
    display: "flex",
    alignItems: "center"
  },
  controlSection: {
    backgroundColor: "white",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  buttonControl: {
    backgroundColor: "white",
    fontSize: "20px",
    margin: "0 8px",
    color: "#5f00a0",
    fontWeight: "500",
    cursor: "pointer"
  },
  noMatches: {
    gridArea: "1 / 1 / 2 / 3",
    fontWeight: 500,
  }
};

function getWidth() {
  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth
  );
}

const TrainCarousel = (props) => {
  const { classes, railcars, railcarFilter, matchFilter, setReverseRailcars, reverseRailcars, selectedRailcarId, setSelectedRailcarId } = props;

  const handleRenderRailcars = () => {
    if (railcars) {
      let _railcars = railcars.filter(r => isRailcarVisible(r, railcarFilter, matchFilter));
      _railcars = reverseRailcars ? _railcars.sort((a, b) => b.sequenceNo - a.sequenceNo) : _railcars;

      return _railcars.length > 0 ?
        _railcars.map((r, i) => {
          return <TrainCard
            data={r}
            key={i}
            selectedRailcarId={selectedRailcarId}
            setSelectedRailcarId={setSelectedRailcarId}
            reverseRailcars={reverseRailcars}
          />
        }) :
        // TODO: This would probably look better as a ghost railcar card.  Just saying. - RDR
        <div className={classes.noMatches}>{I18n.get("train_no_matches")}.</div>
    }
  }

  const handleReverse = () => {
    setReverseRailcars(!reverseRailcars)
  }

  return (
    <div className={classes.railcarContainer}>
      <div className={classes.trainReverse}>
        <span style={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => handleReverse()}>
          <ReverseIcon />
          <button className={`${classes.reverseButton} ${classes.actionText}`}>{I18n.get("train_layout")}</button>
        </span>
      </div>
      <div className={`${classes.railcarCarousel} ${getWidth() > 1600 ? classes.railcarCarouselLarge : ""}`}>
        {handleRenderRailcars()}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(TrainCarousel))
);
